import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import Cookies from 'js-cookie';
import { isWeixin } from '@ivy/fts/utils';
let GoldVirtually = class GoldVirtually extends Vue {
    constructor() {
        super(...arguments);
        this.popupVisible = true;
        this.showBindPhone = false;
        this.products = [];
    }
    get showGoldDiscountValue() {
        let end = this.goldData.discount_end;
        let start = this.goldData.discount_start;
        if (!end)
            return false;
        let endTime = +new Date(end.replace(/-/g, '/'));
        let startTime = +new Date(start.replace(/-/g, '/'));
        let nowTime = +new Date();
        if (endTime <= nowTime ||
            nowTime < startTime ||
            !this.goldData.discounted_value) {
            // 已超过倒计时时间,不展示
            return false;
        }
        return true;
    }
    created() { }
    close() {
        console.log(this);
        this.popupVisible = false;
    }
    async warterPay() {
        const globalParam = {
            distributorMemId: sessionStorage.getItem('_sessionStorageDistributorMemId') ||
                sessionStorage.getItem('_cookieDistributorMemId'),
            appName: sessionStorage.getItem('_sessionStorageAppName') ||
                Cookies.get('_cookieAppName'),
            channel_id: this.$route.query.channel_id ||
                sessionStorage.getItem('_sessionStorageChannelId') ||
                sessionStorage.getItem('_cookieChannelId'),
            invite_activity_id: this.$route.query._sessionStorageInviteActivityId ||
                sessionStorage.getItem('_sessionStorageInviteActivityId'),
            trade_type: isWeixin() ? null : 'MWEB',
        };
        let order = {
            pay_type: 'water',
            hbfq_num: 0,
            type: 'normal',
            receiver_id: false,
            remark: '',
            ignore_gift: 1,
            skus: [
                {
                    id: this.query.skuId,
                    type: this.query.type,
                    num: 1,
                },
            ],
            coupon_user_ids: null,
        };
        let pay = await this.$axios.post(`/api/goods/order/order/submitWaterOrder`, {
            ...order,
            ...globalParam,
            gold_balance: this.goldData.golds_count,
        });
        if (pay.data.code === 20001) {
            console.log('000000', pay.data);
            this.showBindPhone = true;
            return;
        }
        else if (pay.data.code) {
            return this.$Toast(pay.data.message);
        }
        window.location.href = window.location.origin + `/invitation/myExchange`;
        // window.location.href = `http://m.ivydad.com.cn/invitation/myExchange`
    }
};
tslib_1.__decorate([
    Prop()
], GoldVirtually.prototype, "goldData", void 0);
tslib_1.__decorate([
    Prop()
], GoldVirtually.prototype, "query", void 0);
GoldVirtually = tslib_1.__decorate([
    Component({})
], GoldVirtually);
export default GoldVirtually;
